module.exports = __webpack_public_path__ + "e9485768b676aa0e73b547efdc0febf3.pdf";